async function initMocks() {
  if (typeof window === 'undefined') {
    const { server } = await import('./server');
    server.listHandlers();
    server.listen({
      onUnhandledRequest: 'bypass',
    });
  } else {
    const { worker } = await import('./browser');
    worker.listHandlers();
    worker.start({
      onUnhandledRequest: 'bypass',
    });
  }
}

initMocks();

export {};
